import { gql } from '@apollo/client';

export const UpdateFilesGeneric = gql`
  mutation($record: CreateFilesInput!) {
    uploadFile {
      createFiles(record: $record) {
        ok,
        result {
          files {
            id
            url
            title
            type
          }
        }
      }
    }
  }
`;

export const DeleteFilesGeneric = gql`
  mutation($record: DeleteFilesInput!){
    uploadFile {
      deleteFiles(record: $record) {
        ok
      }
    }
  }
`;
